export default __webpack_public_path__ + "static/media/green-check.20afd19d.svg";